import { all } from 'redux-saga/effects';

import { runPendoGuideSaga } from './pendo.action';

export { runPendoGuide, runCustomerSatisfactionSurvey } from './pendo.action';

export const pendoSaga = function* () {
  yield all([runPendoGuideSaga()]);
};
